import {GetProp, SegmentedProps, SelectProps} from "antd";
import {EventCommentEditedField, Role, UserContactType} from "../types/domain.ts";

export const BASE_URL = '/';
export const API_BASE_URL = `${BASE_URL}api`;
export const AUTHORIZE_REDIRECT_URL = `${API_BASE_URL}/auth/authorize`;

export const EVENT_TYPE_OPTIONS: SegmentedProps['options'] = [
    { label: 'Стаффинг портов', value: 'airports' },
    { label: 'Полет по маршруту', value: 'route' }
]

export const ROLE_OPTIONS: SegmentedProps['options'] = [
    { label: 'Читатель РПИ', value: 'fir_reader' },
    { label: 'Менеджер РПИ', value: 'fir_manager' },
    { label: 'Менеджер субдивизиона', value: 'region_manager' },
    { label: 'Стафф', value: 'staff' }
]
export const ROLE_MAP: Record<Role, string> = {
    fir_reader: 'Читатель РПИ',
    'fir_manager': 'Менеджер РПИ',
    'region_manager': 'Менеджер субдивизиона',
    'staff': 'Стафф'
}

export const MOSCOW_AIRPORTS = ['UUEE', 'UUDD', 'UUWW'];

export const EDITED_FIELD_MAP: Record<EventCommentEditedField, { text: string, ending: string }> = {
    "name": {
        text: "название",
        ending: 'о',
    },
    "date": {
        text: "дата",
        ending: 'а'
    },
    "description": {
        text: "описание",
        ending: 'о'
    },
    "image_id": {
        text: "баннер",
        ending: ''
    },
    "airport_time": {
        text: 'время работы аэропорта',
        ending: 'о'
    },
    "route": {
        text: 'маршрут',
        ending: ''
    },
    "airport_add": {
        text: "состав аэропортов (добавление)",
        ending: ""
    },
    "airport_delete": {
        text: "состав аэропортов (удаление)",
        ending: ""
    }
}


// "telegram" | "discord" | "wa" | "tel" | "email"
export const CONTACT_TYPE_OPTIONS: GetProp<SelectProps, 'options'> = [
    { label: 'Telegram', value: 'telegram' },
    { label: 'Discord', value: 'discord' },
    { label: 'WhatsApp', value: 'wa' },
    { label: 'Телефон', value: 'tel' },
    { label: 'Почта', value: 'email' },
];
export const CONTACT_TYPE_TO_LABEL: Record<UserContactType, string> = {
    telegram: 'Telegram',
    discord: 'Discord',
    wa: 'WhatsApp',
    tel: 'Телефон',
    email: 'Почта',
};
export const CONTACT_TYPE_PLACEHOLDERS: Record<UserContactType, string> = {
    telegram: 'https://t.me/JohnDoe',
    discord: '@johndoe',
    wa: '+7 999 123 45 67',
    tel: '+7 999 123 45 67',
    email: 'mail@johndoe.com',
};

export const SUPPORT_EMAIL = 'vatrus-events@vatsim-petersburg.com';